module.exports = __webpack_public_path__ + "img/slide-21.53cd7385.jpg";